var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPencil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13.998,
    height: 13.998,
    viewBox: "0 0 13.998 13.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151",
    "data-name": "Rectangle 151",
    width: 13.998,
    height: 13.998,
    fill: "#7e7e7e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M13.816,3.7,12.5,5.02,8.978,1.5,10.3.182a.621.621,0,0,1,.879,0l2.638,2.638a.622.622,0,0,1,0,.879M1.062,9.418A.624.624,0,0,0,.9,9.707L.019,13.225a.621.621,0,0,0,.754.754L4.291,13.1a.623.623,0,0,0,.289-.164L11.617,5.9,8.1,2.381Z",
    transform: "translate(0 0)",
    fill: "#7e7e7e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/edit-pencil.e3bd8f9bfd7e27350d4a7bb7f8cdeed2.svg";
export { ForwardRef as ReactComponent };